import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Button, Tag, Icon, Input, Form, Popconfirm } from 'antd'

@inject((store: any) => {
    const { synonymsStore } = store
    return { synonymsStore }
})
@observer
class AddKeywords extends Component<any, any> {
    state = {
        keywordValue: null,
        error: null
    }
    handleKeywordChange = keywordValue => {
        this.checkValue(keywordValue)
        this.setState({ keywordValue: keywordValue.replace(',', '').replace('-', '') })
        if (keywordValue.includes(',')) this.addKeyword()
    }
    checkValue = keyword => {
        const { indexedKeywords, pendingKeywords } = this.props.synonymsStore
        const trimmedKeyword = this.trimmKeyword(keyword)
        const pendingValue = pendingKeywords.includes(trimmedKeyword)
        if (trimmedKeyword in indexedKeywords) {
            this.setState({ error: `המושג "${keyword}" כבר קיים באחת הקבוצות` })
        } else if (pendingValue) {
            this.setState({ error: `המושג "${keyword}" כלול במילים שנבחרו` })
        } else if (keyword.split(' ').length > 2) {
            this.setState({ error: 'לא ניתן להזין מושג מעל 2 מילים' })
        } else {
            this.setState({ error: null })
        }
    }
    trimmKeyword = keyword => {
        return keyword
            .replace(',', '')
            .trim()
            .replace('-', '_')
            .replace(/"/g, '')
            .replace(/\s+/g, ' ')
            .replace("'", '')
            .replace(' ', '_')
            .toLowerCase()
    }
    addKeyword = () => {
        const { addPendingKeyword } = this.props.synonymsStore
        const { keywordValue, error } = this.state
        if (!error) {
            addPendingKeyword(this.trimmKeyword(keywordValue))
            this.setState({ error: null, keywordValue: null })
        }
    }
    handleUpdateSynonymGroup = async () => {
        const { keywordValue } = this.state
        if (keywordValue) this.addKeyword()
        const { id, name, keywords } = this.props
        const { updateSynonym, getSynonymsList, applyFilters, toggleKeywordsEdit } = this.props.synonymsStore
        await updateSynonym({ id, name, keywords })
        await getSynonymsList()
        applyFilters()
        toggleKeywordsEdit()
    }
    render() {
        const style = {
            padding: '0.1rem 0.5rem 0.2rem',
            lineHeight: '0.4rem',
            height: '1.3rem',
            margin: '0 0.3rem',
            border: 'none'
        }
        const { id } = this.props
        const { pendingKeywords, keywordsEdit, toggleKeywordsEdit, removePendingKeyword } = this.props.synonymsStore
        const { keywordValue, error } = this.state
        let addButton = <span style={{ margin: '0 0.2rem' }}>הוסף מילים לקבוצה</span>
        if (error) {
            addButton = <span style={{ color: 'red', marginRight: '0.3rem', fontWeight: 'bold' }}>{error}</span>
        } else if (id && id !== 'ADD' && (pendingKeywords.length > 0 || keywordValue)) {
            addButton = (
                <Button type="primary" onClick={() => this.handleUpdateSynonymGroup()} style={{ ...style }}>
                    שמור שינויים
                </Button>
            )
        }
        return (
            <div style={{ textAlign: 'right', width: '100%', margin: '0.3rem' }}>
                {pendingKeywords.map((keyword, index) => (
                    <Tag key={index} style={{ margin: '0.3rem 0 0.3rem 0.5rem', backgroundColor: '#f7d199' }}>
                        <Icon type="close" onClick={() => removePendingKeyword(keyword)} /> {keyword.replace('_', ' ')}
                    </Tag>
                ))}
                <Form
                    onSubmit={e => {
                        e.preventDefault()
                        this.addKeyword()
                    }}
                    style={{ width: 'auto', display: 'inline-block' }}
                >
                    <Input
                        autoFocus={keywordsEdit === id}
                        onChange={e => this.handleKeywordChange(e.target.value)}
                        style={{ maxWidth: '10rem', borderColor: error ? 'red' : 'white' }}
                        size="small"
                        placeholder="מילת מפתח"
                        value={keywordValue}
                    />
                    <Button onClick={() => toggleKeywordsEdit(id)} type="danger" style={{ ...style }}>
                        בטל הוספה
                    </Button>
                    {addButton}
                </Form>
            </div>
        )
    }
}

export default withRouter(AddKeywords)
